// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__BwUUPK8_sK{width:640px}.modalHeadButtons__Pq_sKOAHn3{align-items:start}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/analytics/components/panels/components/pin/analyticsPinPanelModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA,CAGF,8BACE,iBAAA","sourcesContent":[".modal {\n  width: 640px;\n}\n\n.modalHeadButtons {\n  align-items: start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__BwUUPK8_sK`,
	"modalHeadButtons": `modalHeadButtons__Pq_sKOAHn3`
};
export default ___CSS_LOADER_EXPORT___;
